export default "__VITE_ASSET__Q9WJ9A_I__"